/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { Box, Button } from "@mui/material"
import { getDoc, updateDoc, doc, collection, DocumentSnapshot } from "firebase/firestore"
import { db } from "../firebase"
import { toast } from 'react-toastify'
import dayjs from "dayjs"
import { StepFormConfirm } from "./lib/StepFormConfirm"
import { FormProps } from "./lib/StepForm"

const CustomerRegistrationConfirm = () => {
  const urlParams = useParams<{ customerId: string }>()
  const [values, setValues] = useState<Record<string, string|number>>({})
  const [forms, setForms] = useState<Array<FormProps>>([])
  const navigate = useNavigate()

  useEffect(() => {
    getDoc(doc(collection(db, 'forms'), 'customer')).then((_: DocumentSnapshot) => {
      _.exists() && setForms(_.data().conf)
    })
    const storageValues = sessionStorage.getItem('customer')
    storageValues && setValues(JSON.parse(storageValues))
  }, [])

  const onSave = () => {
    updateDoc(doc(collection(db, 'customers'), urlParams.customerId), {...values, updatedAt: dayjs().format('YYYY/MM/DD HH:mm'), status: "registed"}).then(() => {
      toast.success("取引先情報を登録しました")
      sessionStorage.removeItem('customer')
      setValues({})
      navigate("/")
    }).catch(e => {
      toast.error(e)
    })
  }

  return (
    <Box>
      <StepFormConfirm forms={forms} values={values}/>
      <Box mt={2} display="flex" justifyContent="center">
        <Button variant="outlined" onClick={() => navigate(`/customers/${urlParams.customerId}/regist`)}>戻る</Button>
        <Button variant="contained" onClick={onSave} sx={{ ml: 2 }}>登録</Button>
      </Box>
    </Box>

  )
}

export default CustomerRegistrationConfirm
